import { makeStyles } from '@material-ui/core/styles';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { color } from '../../app/theme';
import { CustomerConditionType } from '../../app/types';
import Birthday from './customerConditionSetting/Birthday';
import Gender from './customerConditionSetting/Gender';
import Location from './customerConditionSetting/Location';
import Tag from './customerConditionSetting/Tag';
import TriggerTypeComponent from './customerConditionSetting/TriggerType';
import Mask from './SettingBarMask';

const useStyles = makeStyles(
  {
    top: {
      fontSize: '17px',
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '1',
      letterSpacing: 'normal',
      color: color.$3,
      background: color.$9,
      textAlign: 'center',
      padding: '18px 0 21px',
    },
    bottom: {
      padding: '24px 16px',
      overflowY: 'auto',
      height: 'calc(100vh - 170px)',
    },
  },
  {
    name: 'CustomerConditionSettingBar',
  },
);

const CustomerConditionSettingBar = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { selectedNode } = useSelector(state => state.ma);
  const { triggerType } = selectedNode?.data;

  const settingComponent = useMemo(() => {
    switch (triggerType) {
      case CustomerConditionType.TAG:
        return <Tag />;
      case CustomerConditionType.BIRTHDAY:
        return <Birthday />;
      case CustomerConditionType.GENDER:
        return <Gender />;
      case CustomerConditionType.LOCATION:
        return <Location />;
      default:
        return null;
    }
  }, [triggerType]);

  return (
    <>
      <div className={classes.top}>{t('add-customerConditions')}</div>
      <div id="condition-setting-bar-bottom" className={classes.bottom}>
        <TriggerTypeComponent />
        {settingComponent}
      </div>
      <Mask mainId="condition-setting-bar-bottom" />
    </>
  );
};

export default CustomerConditionSettingBar;
